import React from "react";
import { Authenticator, translations } from "@aws-amplify/ui-react";
import { I18n } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import SignedInWrapper from "./SignedInWrapper";
import Box from "@mui/material/Box";

I18n.putVocabularies(translations);
I18n.setLanguage("fr");

const App: React.FC = () => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    }}
  >
    <Authenticator>
      {({ signOut, user }) => <SignedInWrapper signOut={signOut} user={user} />}
    </Authenticator>
  </Box>
);

export default App;
